I18n.translations || (I18n.translations = {});
I18n.translations["ee"] = I18n.extend((I18n.translations["ee"] || {}), {
  "actions": "Tegevused",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "one": "vale pikkus (peab olema %{count} märk)",
          "other": "vale pikkus (peab olema %{count} märki)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Aadress",
        "name": "Nimi"
      },
      "employee": {
        "active": "Aktiivne",
        "admin": "Üliõigused",
        "email": "E-post",
        "first_name": "Eesnimi",
        "last_name": "Perekonnanimi",
        "role": "Roll"
      },
      "explosive": {
        "available": "Saadaval",
        "box_number": "Kasti number",
        "code": "Üksuse kood",
        "delivery_date": "Tarnekuupäev",
        "grouped_number": "Rühmitatud number",
        "import_name": "Impordifaili nimetus",
        "item_number": "Üksuse number",
        "location": "Asukoht",
        "manufacturer": "Tootja",
        "middlebox_number": "Pakendi number",
        "number_type": "Numbri liik",
        "product_name": "Toote nimetus",
        "product_number": "Toote number",
        "reason": "Põhjus",
        "takeout": "Väljastus",
        "unknown_type": "Tundmatu tüüp"
      },
      "item_setting": {
        "aine_code": "Aine kood",
        "countable_unit": "Loendatav ühik",
        "countable_units": {
          "units": "Tükid",
          "weight": "Kaal"
        },
        "include_in_waybills": "Kaasa saatelehtedele",
        "item_count": "Üksuste arv",
        "item_name_display": "Kuvanimi",
        "item_name_import": "Üksuse nimetus",
        "manually_created": "Käsitsi loodud",
        "set_weight_manually": "Käsitsi määratud kaal",
        "uro_number": "URO number",
        "waybill_position": "Asukoht saatelehel",
        "weight": "Kaal"
      },
      "log": {
        "action": "Tegevus",
        "actions": {
          "atgriešana": "Tagastamine",
          "dzēšana": "Kustutamine",
          "izņemšana": "Väljastamine",
          "korekcija": "Korrektsioon",
          "noliktavas pārvietošana": "Liigutamine laos",
          "pievienošana": "Lisamine",
          "rediģēšana": "Muutmine",
          "saņemšana": "Vastuvõtt",
          "starp-objektu pārvietošana": "Liigutamine objektide vahel"
        },
        "author": "Teostaja",
        "corrected_explosives": "Parandatud lõhkeained",
        "current_destination": "Praegune koht",
        "date": "Kuupäev",
        "destination": "Tööobjekt",
        "destinations": "Tööobjektid",
        "employee": "Töötaja",
        "id_number": "ID number",
        "import_name": "Impordifail",
        "notes": "Märkused",
        "takeout": "Väljastus",
        "takeout_waybill": "Väljastuse saateleht",
        "takeout_waybill_custom_items": "Väljastuse saatelehe käsitsi rida",
        "vehicle": "Sõiduk"
      },
      "pdf_code_printout": {
        "code": "Kood",
        "name": "Nimi",
        "unit": "Ühik",
        "weight": "Kaal"
      },
      "report": {
        "code": "Kood",
        "name": "Nimi",
        "unit": "Ühik",
        "weight": "Kaal"
      },
      "takeout": {
        "active": "Aktiivne?",
        "date": "Kuupäev",
        "destination": "Tööobjekt",
        "employee": "Looja",
        "removed": "Kustutatud",
        "vehicle": "Sõiduk",
        "waybills": "Saatelehed"
      },
      "takeout_waybill": {
        "date": "Kuupäev",
        "destination": "Objekt",
        "direction": "Suund",
        "employee": "Töötaja",
        "initally_edited": "Muudetud",
        "issuance_person": "Väljastaja",
        "issuer": "Väljastaja",
        "legal_entity": "Õiguslik isik",
        "number": "Number",
        "receiver": "Saaja",
        "receiving_person": "Saaja",
        "route": "Marsruut",
        "scope": "Saatelehe objekt",
        "takeout": "Väljastus",
        "to_object": "Objektile",
        "vehicle": "Sõiduk"
      },
      "takeout_waybill_custom_item": {
        "amount": "Kogus",
        "item_setting": "Üksuse seadistused",
        "name": "Nimi",
        "package_name": "Pakend",
        "takeout_waybill": "Väljastuse saateleht",
        "weight": "Kaal"
      },
      "vehicle": {
        "active": "Aktiivne",
        "number_plate": "Numbrimärk"
      },
      "warehouse": {
        "address": "Aadress",
        "city": "Linn",
        "country_code": "Riigikood",
        "latitude": "Laiuskraad",
        "longitude": "Pikkuskraad",
        "name": "Nimi",
        "responsible_employee": "Vastutav isik",
        "zip": "Postiindeks"
      }
    },
    "created_at": "Loodud",
    "errors": {
      "destination": {
        "adress_taken": "Määratud aadress on juba lisatud",
        "generic_error": "Viga sisestatud andmetes",
        "name_blank": "Nimi ei tohi olla tühi"
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Töötajal on juba identne väljastus",
        "missing_destinations": "Peab olema valitud vähemalt üks tööobjekt"
      },
      "takeout_waybill": {
        "destination_unknown": "Teadmata"
      }
    },
    "models": {
      "destination": "Tööobjekt",
      "employee": "Töötaja",
      "explosive": "Lõhkeaine",
      "item_setting": "Üksuse seadistus",
      "log": "Tegevuste logi",
      "pdf_code_printout": "PDF koodide väljatrükk",
      "report": "Aruanne",
      "takeout": "Lõhkeainete väljastus",
      "takeout_waybill": "Saateleht",
      "takeout_waybill_custom_item": "Käsitsi sisestatav üksus",
      "vehicle": "Sõiduk",
      "warehouse": "Ladu"
    },
    "removed": "Kustutatud",
    "updated_at": "Muudetud"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Tagasi sisselogimisele",
        "description": "Vali oma kontole uus parool.",
        "password_confirmation_label": "Kinnita uus parool",
        "password_label": "Uus parool",
        "submit": "Uuenda parooli",
        "title": "Sea parool"
      },
      "new": {
        "back_to_login": "Tagasi sisselogimisele",
        "description": "Sisesta töö e-post, et saada parooli seadistamise link.",
        "submit": "Saada link",
        "title": "Parooli lingi taotlemine"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "või",
        "email_login_button": "Logi sisse e-postiga",
        "email_login_title": "Sisselogimine töö e-posti kaudu",
        "google_auth": "Logi sisse Google'iga",
        "password_label": "Parool",
        "password_link_text": "Unustasin parooli",
        "remember_me": "Pea mind meeles",
        "title": "Logi sisse BALROCK lao arvestusse"
      }
    }
  },
  "back": "Tagasi",
  "cancel": "Tühista",
  "controllers": {
    "application": {
      "not_logged_in": "Pead süsteemi sisse logima, et vaadata soovitud lehte!",
      "not_permitted": "Sul ei ole õigust vaadata soovitud lehte!",
      "report_ready": "Sinu aruanne: %{report_name} on valmis! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Vale e-post või parool. Kontrolli sisestatud andmeid.",
        "no_access": "Sinu juurdepääs süsteemile on keelatud. Võta ühendust administratsiooniga.",
        "server_error": "Tekkis serveri viga. Palun proovi uuesti."
      }
    },
    "destinations": {
      "object_added": "Objekt edukalt lisatud",
      "object_edited": "Objekt edukalt muudetud"
    },
    "employees": {
      "employee_added": "Töötaja edukalt lisatud",
      "employee_added_with_invite": "Töötaja lisatud ja parooli seadistamise link saadetud",
      "employee_edited": "Töötaja andmed edukalt uuendatud",
      "password_email_failed": "Töötaja lisatud, kuid parooli lingi saatmine ebaõnnestus."
    },
    "explosives": {
      "all_items_moved": "Kõik märgitud üksused edukalt teisaldatud",
      "all_items_removed": "Kõik üksused edukalt likvideeritud",
      "all_items_returned": "Kõik üksused edukalt lattu tagastatud",
      "database_updated": "Andmebaas uuendatud",
      "failed_import_file_count": "%{count_failed} faili %{count_total}-st ei õnnestunud importida",
      "failed_to_add": "%{count} üksust ei õnnestunud lisada",
      "failed_to_import": "Faili %{filename} ei õnnestunud importida, sest %{reason}",
      "import_in_progress": "Faili imporditakse. Tulemusest teavitatakse sind.",
      "item_already_at_destination": "juba sihtlaos",
      "item_not_found": "ei leitud",
      "item_removed": "kustutatud",
      "item_unavailable": "pole saadaval",
      "multiple_warehouses": "Viga! Skaneeritud üksused asuvad mitmes laos, palun täpsusta nende numbrid.",
      "no_files_selected": "Ühtegi faili pole valitud",
      "no_item_settings": "Mõnel üksusel puuduvad seaded",
      "no_items_found": "Antud numbri vahemikust ei leitud ühtegi üksust",
      "no_warehouse": "--",
      "not_all_items_moved": "Tekkis viga üksuste (kõigi) teisaldamisel, palun kontrolli üksuste loendit.",
      "not_all_states_changed": "Tekkis viga ja mõne üksuse olekut ei muudetud",
      "not_available_for_movement": "Lõhkeaine üksus pole saadaval",
      "partial_items_moved": "Edukalt teisaldatud %{moved} märgitud üksust. %{failed} märgitud üksust ebaõnnestus (nt %{examples}).",
      "range_must_be_numeric": "Vahemiku algus ja lõpp peavad olema numbrilised",
      "range_required": "Sisesta nii vahemiku algus kui ka lõpp",
      "range_start_after_end": "Vahemiku algus peab olema lõpust väiksem või sellega võrdne",
      "range_too_large": "Vahemik on liiga suur (max %{max} üksust)",
      "warehouse_not_selected": "Sihtladu pole valitud"
    },
    "item_settings": {
      "created": "Üksuse seaded edukalt loodud",
      "deleted": "Üksuse seaded edukalt kustutatud",
      "edited": "Üksuse seaded edukalt uuendatud",
      "failed_to_create": "Viga üksuse seadete loomisel",
      "failed_to_edit": "Viga üksuse seadete uuendamisel",
      "unable_to_delete": "Ei saa kustutada, kuna see on seotud lõhkeainega"
    },
    "reports": {
      "error": "Tekkis viga. Palun loo aruanne uuesti!",
      "no_period": "Palun määra lõhkeainete liikumise aruande ajaperiood!",
      "no_report": "Aruandefaili ei leitud!",
      "preparation_error": "Aruande %{report_name} koostamisel tekkis viga"
    },
    "sessions": {
      "invalid_credentials": "Vale e-post või parool. Kontrolli sisestatud andmeid.",
      "no_access": "Sinu juurdepääs süsteemile on keelatud. Võta ühendust administratsiooniga.",
      "server_error": "Tekkis serveri viga. Palun proovi uuesti."
    },
    "takeout_waybills": {
      "data_updated": "Saatelehe andmed uuendatud",
      "waybill_edited": "Saateleht on juba muudetud"
    },
    "takeouts": {
      "add_back_to_warehouse": "Pane üksused tagasi õigesse lattu!",
      "item_not_removed": "Viga, üksust ei õnnestunud eemaldada",
      "item_removed": "Üksus edukalt eemaldatud",
      "need_more_data": "Palun täpsusta saatelehe andmeid",
      "no_access": "Sul ei ole juurdepääsuõigust",
      "no_access_system_error": "Süsteemis tekkis viga sinu juurdepääsuõiguste autoriseerimisel",
      "scan_to_next_object_title": "Skaneeri üksused, mida viia objekti %{destination}",
      "takeout_confirmation_modal_title": "Kas oled kindel, et soovid minna objekti %{destination} üksustega:",
      "takeout_exists": "Viga! Selline väljastus on juba olemas!",
      "takeout_unavailable": "Väljastus ei ole saadaval",
      "to_next_object_button": "Liigu objekti %{destination}"
    },
    "vehicles": {
      "created": "Auto edukalt lisatud",
      "edited": "Auto edukalt muudetud"
    },
    "warehouses": {
      "unable_to_delete": "Ladu ei õnnestunud kustutada",
      "warehouse_created": "Ladu edukalt loodud",
      "warehouse_deleted": "Ladu edukalt kustutatud",
      "warehouse_edited": "Lao andmed edukalt uuendatud"
    }
  },
  "create": "Loo",
  "delete": "Kustuta",
  "destinations": {
    "edit": {
      "title": "Objekti muutmine"
    },
    "form": {
      "adress_note": "Aadress peab olema unikaalne.",
      "adress_placeholder": "Objekti aadress",
      "name_placeholder": "Objekti nimi"
    },
    "new": {
      "title": "Uue objekti lisamine"
    }
  },
  "download": "Laadi alla",
  "edit": "Muuda",
  "edit_object": "Muuda",
  "employees": {
    "edit": {
      "title": "Töötaja muutmine"
    },
    "form": {
      "email_note": "Peab olema @gmail.com või @balrock.lv e-post.",
      "email_placeholder": "Sisesta töötaja e-post",
      "first_name_note": "Nimi ei tohi sisaldada numbreid.",
      "first_name_placeholder": "Sisesta töötaja eesnimi",
      "last_name_note": "Perekonnanimi ei tohi sisaldada numbreid.",
      "last_name_placeholder": "Sisesta töötaja perekonnanimi"
    },
    "index": {
      "employee_enabled": "Süsteemi juurdepääs",
      "subtitle": "Töötajate ja ligipääsude haldamine",
      "title": "Töötajad"
    },
    "new": {
      "title": "Uue töötaja lisamine"
    }
  },
  "explosive_unit": "Üksus",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Kaamera pole saadaval!",
      "no_camera_alert_message": "Võib-olla pole andnud selle kasutamiseks luba või JavaScript pole lubatud.",
      "subtitle": "Skaneeri kood või sisesta number ja vali edasine toiming",
      "title": "Lõhkeainete koguse korrigeerimine"
    },
    "index": {
      "title": "Vigased kirjed"
    },
    "location": {
      "removed": "-- (Käsitsi kustutatud)",
      "used": "Kasutatud - %{destination_name}",
      "warehouse": "Ladu"
    },
    "new": {
      "drop_files": "Lohista failid siia",
      "import": "Impordi",
      "upload_note": "Vali 1 või mitu .xml või .xlsx faili."
    },
    "warehouse_movement": {
      "entry_mode_label": "Sisestusrežiim",
      "no_camera_alert": "Kaamera pole saadaval!",
      "no_camera_alert_message": "Võib-olla pole andnud selle kasutamiseks luba või JavaScript pole lubatud.",
      "process_range": "Töötle vahemik",
      "range_end": "Vahemiku lõpp",
      "range_end_placeholder": "nt 275998",
      "range_entry": "Vahemikusisestus",
      "range_entry_title": "Vahemikusisestus:",
      "range_start": "Vahemiku algus",
      "range_start_placeholder": "nt 275961",
      "single_entry": "Üksiksisestus",
      "subtitle": "Vali ladu, kuhu lõhkeaineid lisada, seejärel skaneeri kood või sisesta number",
      "title": "Lõhkeainete liigutamine ladude vahel",
      "warehouse_select_label": "Ladu, kuhu lisada",
      "warehouse_select_placeholder": "Vali ladu"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Üksuste kaalu ja saatelehtede seaded",
      "title": "Üksuste seaded"
    },
    "item_setting_row": {
      "weight_note": "Vaike kaal"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Viga!"
    },
    "correction_code_scanner": {
      "camera_alert": "Kaamera pole saadaval!",
      "correction_modal_title": "Koguse korrigeerimine",
      "current_warehouse_name": "Ladu",
      "explosive_type": "Lõhkeaine",
      "explosive_units": "üksused",
      "no_camera_permission": "Võib-olla pole andnud selle kasutamiseks luba või JavaScript pole lubatud.",
      "remove_explosives": "Kustuta laost",
      "revive_explosives": "Taasta arvestusse (ilma laota)",
      "some_units_deleted": "kuid mõned selles olevad üksused on juba kustutatud.",
      "which_has": ", milles on "
    },
    "file_upload": {
      "files_selected": " faili valitud",
      "import_notification": "Andmeid imporditakse, palun oota."
    },
    "item_settings": {
      "success": "Kõik õnnestus"
    },
    "loading_screen": {
      "please_wait": "Palun oota..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Lisa valitud üksused",
      "already_scanned": "Kood on juba skaneeritud",
      "camera_off": "Kaamera on välja lülitatud!",
      "confirm_scanned_items": "Kinnitan, et skaneeritud üksused ja nende staatused vastavad tõele",
      "confirm_used_items": "Kinnitan, et kõik väljastatud üksused on objektil kasutatud",
      "error_occurred": "Ilmnes viga",
      "failed_to_remove_item": "Viga üksuse eemaldamisel. Proovi uuesti või võta ühendust administraatoriga!",
      "item_already_scanned": "Üksus(ed) on juba skaneeritud.",
      "item_returnable": "Tagastatav",
      "item_used": "Kasutatud",
      "items_return_confirmation": "Kas soovid tagastada järgmised üksused?",
      "items_take_confirmation": "Kas soovid väljastada järgmised üksused?",
      "no_items_scanned": "Üksusi pole skaneeritud",
      "range_modal_title": "Lisa üksused vahemikust",
      "refresh_for_camera": "Kaamera uuesti käivitamiseks laadi leht uuesti!",
      "return_scanned": "Skaneeritud üksused loetakse lattu tagastatuks.",
      "scan_returnable_items": "Tagastatavate üksuste skaneerimine",
      "scan_used_items": "Kasutatud üksuste skaneerimise režiim",
      "writeoff_scanned": "Skaneeritud üksused loetakse objektil kasutatuks. !! Tagastatakse kõik väljastatud üksused, mis on skaneeritud üksusega samal pakenditasemel !!"
    },
    "warehouse_movement": {
      "confirm_move": "Kinnita liigutamine",
      "explosive_type": "Lõhkeaine",
      "explosive_units": "üksused",
      "from_warehouse": "Laost %{warehouse}",
      "included_ids": "Kaasatud ID-d (%{included} / %{total})",
      "items_badge": "%{count} üksust",
      "modal_title": "Lõhkeainete liigutamine ladude vahel",
      "modal_title_short": "Lõhkeainete liigutamine",
      "move_error": "Tekkis viga üksuste (kõigi) liigutamisel, palun kontrolli üksuste loendit.",
      "move_success": "Lõhkeained edukalt liigutatud",
      "move_to_button": "Liiguta",
      "move_warehouse_info": "Liiguta #{from} → #{to}",
      "no_items_found": "Antud numbri vahemikust ei leitud ühtegi üksust",
      "no_items_selected": "Vali vähemalt üks üksus liigutamiseks",
      "range_failures_preview": "%{count} üksust ei saa liigutada (nt %{examples}).",
      "range_label": "Vahemik: %{start} → %{end}",
      "range_must_be_numeric": "Vahemiku algus ja lõpp peavad olema numbrilised",
      "range_required": "Sisesta nii vahemiku algus kui lõpp",
      "range_start_after_end": "Vahemiku algus peab olema lõpust väiksem või sellega võrdne",
      "some_units_deleted": "kuid mõned selles olevad üksused on juba kustutatud.",
      "subtitle_range": "Vali sihtladu, seejärel sisesta või skaneeri numbri vahemik",
      "to_warehouse": "Lattu %{warehouse}",
      "total_items": "%{count} üksust",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "Ladu pole valitud",
      "which_has": ", milles on "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Sain aru",
      "title": "Viga!"
    },
    "application": {
      "title": "Balrocki lao arvestus"
    },
    "camera_switch": {
      "use_camera": "Kasuta kaamerat"
    },
    "confirmation_modal": {
      "confirm": "Kinnita",
      "confirmation": "Kas oled kõik väljastatud üksused ära kasutanud?",
      "title": "Kinnitamine"
    },
    "delete_modal": {
      "confirmation": "Kas oled kindel, et soovid kustutada %{deletable_object}?",
      "title": "Kustutamise kinnitus"
    },
    "external_scanner": {
      "item_number_placeholder": "Manuaalne numbri sisestus",
      "search": "Otsi",
      "title": "Manuaalne sisestus või skaneerimine välise skanneriga:"
    },
    "loading_overlay": {
      "please_wait": "Palun oota..."
    },
    "sidebar": {
      "additional_code_printouts": "Lisakoodide printimine",
      "back": "Tagasi",
      "correction": "Koguse korrigeerimine",
      "home": "Avaleht",
      "language": "Keel",
      "logout": "Logi välja",
      "logs": "Sündmuste loend",
      "menu": "Menüü",
      "receive_explosives": "Vastuvõtmine",
      "reports": "Aruanded",
      "return": "Tagastamine",
      "settings": {
        "destinations": "Objektid",
        "employees": "Personal",
        "item_settings": "Üksuste seaded",
        "title": "Seaded",
        "vehicles": "Sõidukid"
      },
      "takeout": "Väljastamine",
      "title": "Balrocki lõhkeainete ladu",
      "warehouse_movement": "Laoülese liikumise haldamine",
      "warehouses": "Laod",
      "waybills": "Saatelehed"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Konsolideeritud aruanne (kõik laod)",
      "description": "Palun valige, millised ladu aruandesse kaasata:",
      "prepare_report": "Koosta aruanne",
      "title": "Valige ladu"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Parandatud üksuste arv:",
      "corrected_explosives_table": "Korrigeeritud lõhkeained",
      "correction_action": "Korrigeerimistoiming:",
      "correction_date": "Kuupäev:",
      "deletion": "❌ Kustutamine",
      "employee": "Korrigeerija:",
      "return": "✅ Tagastamine lattu",
      "title": "Lõhkeainete korrigeerimise ülevaade"
    },
    "helper_row": {
      "changes": "Muudatused",
      "corrected_explosives_count": "Korrigeeritud lõhkeainete arv",
      "correction_action": "Korrigeerimistoiming",
      "deletion": "Kustutamine",
      "edited": "Muudetud",
      "edited_object": "Muudetud objekt",
      "error": "Midagi läks valesti",
      "imported_explosives_count": "Imporditud lõhkeainete arv",
      "moved_between": "Liigutatud vahel",
      "moved_explosives_count": "Liigutatud üksuste arv",
      "movement_route": "Liikumismarsruut",
      "precise_time": "Täpne aeg",
      "return": "Tagastamine lattu",
      "returned_explosives_count": "Tagastatud üksuste arv",
      "taken_explosives_count": "Väljastatud üksuste arv",
      "takeout_responsible_employee": "Väljastamise vastutaja (looja)",
      "to_overview": "Ülevaatele",
      "used_explosives_count": "Kasutatud lõhkeainete arv",
      "used_explosives_weight": "Kasutatud lõhkeainete kaal"
    },
    "index": {
      "filtering": "Filtreerimine",
      "subtitle": "Sündmused on sorteeritud kahanevalt vanuse järgi",
      "title": "Tegevuste logi"
    },
    "log_querry": {
      "clear_filters": "Tühista filtrid",
      "filter": "Filtreeri"
    },
    "log_table": {
      "no_results": "Antud kriteeriumidele ei leitud midagi"
    },
    "warehouse_moved_explosives": {
      "employee": "Liigutamise teostaja:",
      "moved_between": "Liigutatud vahel",
      "moved_explosives_count": "Liigutatud üksuste arv",
      "moved_explosives_table": "Liigutatud lõhkeained",
      "movement_date": "Kuupäev:",
      "title": "Lõhkeainete liigutamine ladude vahel"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Aktiivsed lõhkeainete väljastused:",
      "current_employee": "Kasutaja:",
      "employee_admin": "Administraator",
      "employee_regular": "Töötaja",
      "employee_role": "Staatus:",
      "explosives_in_warehouse": "Lõhkeainete arv laos:",
      "no_actions": "Sul pole veel tegevusi.",
      "previous_actions": "Sinu viimased tegevused: ",
      "title": "Balrocki lõhkeainete lao arvestus"
    }
  },
  "new_object": "Lisa",
  "number": {
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Miljard",
            "other": "Miljardit"
          },
          "million": {
            "one": "Miljon",
            "other": "Miljonit"
          },
          "quadrillion": {
            "one": "Kvadriljon",
            "other": "Kvadriljonit"
          },
          "thousand": {
            "one": "Tuhat",
            "other": "Tuhat"
          },
          "trillion": {
            "one": "Triljon",
            "other": "Triljonit"
          },
          "unit": {
            "one": "",
            "other": ""
          }
        }
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Leht %{page_input} / %{pages}",
    "info": {
      "multiple_pages": "Kuvatakse %{item_name} <b>%{from}-%{to}</b> kokku <b>%{count}</b>",
      "no_items": "%{item_name} ei leitud",
      "single_page": "Kuvatakse <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Kirje",
      "other": "Kirjed"
    },
    "items_selector_js": "Lehel kuvatakse %{items_input} %{item_name} kirjet",
    "nav": {
      "gap": "&hellip;",
      "next": "Järgmine&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Eelmine"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Prinditavate koodide loomine ebaõnnestus",
      "invalid_code_type": "Vale üksuse koodi tüüp"
    },
    "index": {
      "no_results": "Midagi ei leitud",
      "package_search": "Prinditavate pakendiüksuste otsing nime järgi",
      "package_search_placeholder": "Nimi või selle osa",
      "search": "Otsi",
      "title": "Üksuste koodiduplikaatide printimine"
    },
    "table_row": {
      "get_pdf": "Laadi alla PDF koodileht"
    }
  },
  "remove": "Eemalda",
  "reports": {
    "index": {
      "available_explosives_count": "Hetkel saadaval %{count} üksust",
      "available_explosives_report": "Saadaval lõhkeained",
      "date_range": "Ajaperiood",
      "explosive_movement_report": "Lõhkeainete liikumine ajaperioodil",
      "explosive_summary": "Lõhkeainete jäägid laos nimetuste kaupa",
      "explosives_in_warehouse": "Laos on järgmised üksused:",
      "prepare_report": "Koosta",
      "tab_all": "Kõik",
      "tab_without_warehouse": "Ilma laota",
      "title": "Süsteemi aruanded .xlsx formaadis"
    },
    "quick_report_tab": {
      "total_amount": "Kokku:",
      "units": "tk",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Kood",
              "Tootja",
              "Nimetus",
              "Kasti number",
              "Pakendi number",
              "Üksuse number",
              "URO number",
              "AINE kood",
              "Impordifail",
              "Asukoht",
              "Vastutaja"
            ],
            "no_employee": "Üksusel pole vastutajat",
            "report_row_title": "Saadaval lõhkeainete ülevaade %{date}",
            "report_warehouse_row_title": "Saadaval lõhkeainete ülevaade laos %{warehouse} - %{date}",
            "warehouse_headers": [
              "Kood",
              "Tootja",
              "Nimetus",
              "Kasti number",
              "Pakendi number",
              "Üksuse number",
              "URO number",
              "AINE kood",
              "Impordifail",
              "Vastutaja"
            ],
            "worksheet_title": "Saadaval lõhkeained"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "AktiivneVäljastus-%{index}-%{date}",
              "returned": "TagastatudVäljastus-%{index}-%{date}"
            },
            "states": {
              "active": "väljastatud",
              "returned": "tagastatud",
              "used": "kasutatud"
            },
            "takeout_explosives_headers": [
              "Kood",
              "Nimetus",
              "Kast",
              "Pakend",
              "Lõhkeaine",
              "Impordifail",
              "Staatus"
            ],
            "takeout_info_headers": [
              "Töötaja",
              "Tööobjekt",
              "Sõiduk",
              "Staatus",
              "Väljastatud ühikuid",
              "Kasutatud ühikuid"
            ],
            "worksheet_title": "Lõhkeainete väljastamise/tagastamise ülevaade"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Veoautojuht",
    "employee": "Töötaja",
    "manager": "Järelevalvaja"
  },
  "save": "Salvesta",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "Kõik üksused edukalt maha kantud!",
        "failed_to_return": "{count} üksust ei õnnestunud tagastada.",
        "returned": "Üksused edukalt tagastatud!",
        "server_error": "Serveri viga üksuste tagastamisel!"
      },
      "take_explosives": {
        "failed_to_take": "{count} üksust ei õnnestunud väljastada.",
        "server_error": "Serveri viga üksuste väljastamisel!",
        "success": "Üksused edukalt väljastatud"
      },
      "type": "Lõhkeaine"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Lisa lattu",
      "expand": "Laienda",
      "title": "Lõhkeained ilma laota"
    }
  },
  "state": "Sisse lülitatud",
  "takeout_waybills": {
    "button_title_from": "Saateleht VÄLJA",
    "button_title_to": "Saateleht KASUTUSSE",
    "custom_item_form_row": {
      "not_included_in_waybill": "See üksus ei ole kaasatud saatelehesse"
    },
    "edit": {
      "manual_items": "Manuaalselt sisestatavad üksused",
      "title": "Saatelehe %{number} muutmine",
      "view_waybill": "Vaata saatelehte",
      "waybill_persons": "Saatelehe isikud"
    },
    "index": {
      "subtitle": "Kõik loodud saatelehed",
      "title": "Saatelehed"
    },
    "pdf": {
      "default_packaging_type": "papist kast",
      "failed_to_create": "Saatelehe loomine ebaõnnestus",
      "header": {
        "date": "Kuupäev",
        "route": "Marsruut",
        "waybill": "Saateleht",
        "waybill_nr": "VEOKIRI nr."
      },
      "item_counts": {
        "kogus": "Kogus",
        "laohoidja": "Laohoidja:",
        "seeria_nr": "Võetud:",
        "tagastus": "Tagastus:",
        "vedaja_lohkaja": "Vedaja/Lõhkaja/Lõhekmeister:",
        "veokiri_nr": "Veokiri nr:"
      },
      "legal_entity": {
        "address": "Aadress",
        "reg_number": "Reg. nr.",
        "title": "Õiguslik isik",
        "vat_number": "KMKR nr."
      },
      "no_custom_item_data": "Saatelehe loomine ebaõnnestus, kuna kõigil selles olevatel üksustel puudub kaal",
      "sender_receiver": "Saatja/Saaja:",
      "signatures": {
        "carrier_received": "Aine võttis vastu vedaja:",
        "carrier_returned": "Aine jäägi tagastas vedaja laohoidjale:",
        "carrier_title": "Vedaja:",
        "date": "Kuupäev:",
        "issuer_title": "Kauba väljastamise eest vastutavad isikud:",
        "miner_received": "Aine võttis vastu vedajalt minöör:",
        "miner_returned": "Aine jäägi tagastas minöör vedajale:",
        "name": "Ees- ja perekonnanimi:",
        "name_signature_date": "nimi, allkiri, kuupäev",
        "receiver_title": "Kauba vastuvõtmise eest vastutavad isikud:",
        "responsible_title": "Vastutav isik:",
        "signature": "Allkiri:",
        "warehouse_keeper_issued": "Veokiri koostas ja aine andis välja laohoidja",
        "warehouse_keeper_received": "Aine jäägi võttis vastu laohoidja:"
      },
      "table": {
        "aine_code": "Aine kood",
        "consumption": "Kulu\nkg/tk/jm",
        "description": "Kirjeldus",
        "name": "Nimetus",
        "package_count": "Pakendite arv (tk)",
        "packaging": "Pakend",
        "quantity": "Kogus (tk)",
        "remainder": "Jääk\nkg/tk/jm",
        "source_warehouse": "Ladu",
        "substance_code": "Aine kood",
        "substance_name_description": "Aine nimetus ja kirjeldus",
        "taken": "Võetud\nkg/tk/jm",
        "total": "Kokku:",
        "total_weight": "Kogukaal (kg):",
        "uro_number": "URO nr.",
        "weight_kg": "Kaal (kg)"
      },
      "total_cargo": "Veoste üldkogus:",
      "transport": {
        "self_transport": "omavedu",
        "type": "Veo liik",
        "vehicle_reg": "Sõiduki reg. nr."
      },
      "units": {
        "kg": "kg",
        "pcs": "tk"
      }
    },
    "table_row": {
      "to_destination": "Objektile",
      "to_warehouse": "Lattu"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "tk"
    },
    "index": {
      "active_title": "Aktiivsed väljastused (pooleli)",
      "cta": "Vajuta mõnele või loo uus!",
      "historical_title": "Lõpetatud väljastused (viimased 50)",
      "new_takeout": "Uus väljastus",
      "no_active_takeouts": "Aktiivseid väljastusi pole.",
      "no_historical_takeouts": "Lõpetatud väljastusi veel pole.",
      "no_takeouts": "Väljastusi veel pole.",
      "type": "Väljastus"
    },
    "new": {
      "add_destination": "Lisa",
      "choose_destination": "Vali tööobjekt",
      "choose_vehicle": "Vali sõiduk",
      "destinations": "Tööobjektid",
      "drag_to_reorder": "Lohista, et järjekorda muuta",
      "mandatory_field": "See väli on kohustuslik"
    },
    "returns": {
      "p_text": "Väljastuse valimiseks vajuta vastavale reale",
      "return": "Tagastamine"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Saadaolevad üksused:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Ülejäänud üksused:",
      "title": "Kõrvaldada kõik ülejäänud lõhkeained"
    },
    "scan_takeout_explosives": {
      "title": "Väljastada valitud lõhkeained"
    },
    "scanner": {
      "delete_takeout": "Kustuta väljastus",
      "destination": "Objekt: %{destination}",
      "item_count": "Üksuste arv: %{count}",
      "no_camera_alert": "Kaamera pole saadaval",
      "no_camera_subalert": "Võib-olla pole andnud selle kasutamiseks luba",
      "scan_only_used_explosives": "Vali <strong>ainult</strong> objektil kasutatud üksused",
      "scanned": "Skaneeritud:",
      "this_takeout": "see väljastus",
      "title": "Pakendikoodide skaneerimine",
      "vehicle": "Sõiduk: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Aktiivne",
      "date": "Kuupäev:",
      "destination": "Tööobjekt:",
      "employee": "Vastutaja:",
      "inactive_takeout": "❌ - Mitteaktiivne/Tagastatud",
      "state": "Staatus:",
      "subtitle": "*Tabelit saab mobiilse seadme korral horisontaalselt kerida",
      "title": "Lõhkeainete väljastamise/tagastamise ülevaade",
      "title_2": "Väljastatud lõhkeaineüksused",
      "title_3": "Kasutatud lõhkeaineüksused on punasega märgitud",
      "vehicle": "Sõiduk:"
    },
    "table": {
      "button_edit_return": "Muuda",
      "button_return_to_warehouse": "Tagasta lattu",
      "button_take_out": "Väljasta",
      "button_to_next_object": "Järgmisele objektile",
      "items": "%{count} üksust",
      "title": "Lõhkeainete %{action}"
    },
    "taken_explosives": {
      "no_person": "Üksusel pole vastutajat",
      "person": "Väljastaja: %{name}",
      "title": "Väljastatud üksused:",
      "unknown": "teadmata"
    }
  },
  "vehicles": {
    "edit": {
      "title": "Auto muutmine"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Oluline on järgida numbrimärgi formaati"
    },
    "index": {
      "delete_modal_text": "sõiduk %{number_plate}",
      "subtitle": "Lõhkeainete veoks mõeldud sõidukite haldamine",
      "title": "Sõidukid"
    },
    "new": {
      "title": "Uue auto lisamine"
    }
  },
  "view": "Vaata",
  "warehouses": {
    "edit": {
      "title": "%{warehouse_name} muutmine"
    },
    "form": {
      "country_code_hint": "Kasuta ISO 3166-1 alpha-2 koodi, nt LV.",
      "latitude_hint": "Kasuta laiuskraade, nt 56.96130.",
      "longitude_hint": "Kasuta pikkuskraade, nt 24.12540.",
      "responsible_person_prompt": "Vali vastutaja"
    },
    "index": {
      "subtitle": "Ladude loend ja haldamine",
      "title": "Laod"
    },
    "new": {
      "title": "Uue lao lisamine"
    },
    "show": {
      "details_title": "Lao teave",
      "explosives_title": "Lõhkeained laos",
      "map_title": "Asukoht kaardil",
      "no_explosives": "Selles laos pole praegu lõhkeaineid."
    }
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
});
I18n.translations["lt"] = I18n.extend((I18n.translations["lt"] || {}), {
});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
});
